//import firebase from 'firebase'
import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import HomeContent from './HomeContent'
import { setTitle, fetchPracticeTypes, fetchPractices } from "../../actions/index";

@connect((store) => {
    return {User: store.User.User, app: store.app}
})
class Home extends React.Component {

    componentWillMount() {
        const {User, dispatch, router, route} = this.props;
        dispatch(setTitle('SpecialT'));
        // this.props.dispatch(fetchPracticeTypes());
        if(User.admin){
            this.props.dispatch(fetchPractices());
        }

        var url_string = window.location.href;
		var url = new URL(url_string);
        var redirectUrl = (url.searchParams.has('redirect')) ? url.searchParams.get('redirect'): null;
        
        if (redirectUrl !== null) {
            router.replace(redirectUrl);
        }

        // route user
        if (!route.force) {
            if (User.therapist) {
                router.replace('/therapists')
            } else if (User.parent) {
                router.replace('/parents')
            } else if (User.owner) {
                router.replace('/practice_admin')
            }
        }
        this.setAsOwner = this.setAsOwner.bind(this)
    }

    setAsOwner() {
        const { router } = this.props;
        router.push(`/page/register_practice`)
    }

    render() {
        return <HomeContent setAsOwner={this.setAsOwner} User={this.props.User}/>
    }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.jsx